import { render, staticRenderFns } from "./assignStaffModal.vue?vue&type=template&id=6194c875&"
import script from "./assignStaffModal.vue?vue&type=script&lang=js&"
export * from "./assignStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6194c875')) {
      api.createRecord('6194c875', component.options)
    } else {
      api.reload('6194c875', component.options)
    }
    module.hot.accept("./assignStaffModal.vue?vue&type=template&id=6194c875&", function () {
      api.rerender('6194c875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/assignStaffModal.vue"
export default component.exports